import React from "react";
export default function Card(props) {
  return (
    <div className="col-sm-6 col-xl-4 col-lg-4 col-md-4 mb-1">
      <div
        className="card custom-card"
        style={{
          borderBottom: "2px solid royalblue",
          borderRadius: "10px",
        }}
      >
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between">
            {/* Title */}
            <p className="mb-1 tx-inverse">{props.title}</p>
            {/* Icon */}
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                background: "wheat",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
              }}
            >
              <i
                className={`${props.icon} fs-20 text-primary`}
                style={{ lineHeight: "1" }}
              />
            </div>
          </div>
          {/* Value */}
          <div>
            <h3 className="">{props.value}</h3>
          </div>
          <hr />
          {/* Footer */}
          <div className="expansion-label d-flex align-items-center">
            <span className="text-muted">***</span>
            <span className="ml-auto d-flex align-items-center">
              <i className="fas fa-caret-up mr-1 text-success" />
              {props.perc}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
